export const issueCategorySelector = state => state.entities.issueCategories;
